import { Icon, Menu } from "materia"
import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import s from "./styles.module.scss"

type DropdownAboutProps = { privacyPolicy: string | null }
export const DropdownAbout = ({ privacyPolicy }: DropdownAboutProps) => {
  const { t } = useTranslation()

  return (
    <Menu>
      <Menu.Trigger dataTestId="dropdown-about-trigger">
        <div className={s.headerMenuItem}>
          <Icon
            icon="InfoCircle"
            size="extraLarge"
            className={s.headerMenuItem__thumbnail}
          />
          <div className={s.headerMenuItem__content}>
            <div className={s.headerMenuItem__title}>{t("settings.ABOUT")}</div>
          </div>
        </div>
      </Menu.Trigger>

      <Menu.Content>
        <AboutLink href="https://legal.attensi.com/min-spec.html">
          {t("settings.MINIMUM_TECHNICAL_SPECIFICATION")}
        </AboutLink>

        {privacyPolicy && (
          <AboutLink href="https://attensi.com/privacy-policy/">
            {t("settings.PRIVACY_POLICY")}
          </AboutLink>
        )}

        <AboutLink href="https://legal.attensi.com/eula.html">
          {t("settings.TERMS_OF_USE")}
        </AboutLink>

        <AboutLink href="https://legal.attensi.com/licenses.html">
          {t("settings.LICENSES")}
        </AboutLink>

        <AboutLink href="https://legal.attensi.com/cookie-policy.html">
          {t("settings.COOKIE_POLICY")}
        </AboutLink>
      </Menu.Content>
    </Menu>
  )
}

type AboutLinkProps = { children: ReactNode; href: string }
const AboutLink = ({ children, href }: AboutLinkProps) => (
  <Menu.Item as="a" href={href} target="_blank" rel="noreferrer">
    {children}
  </Menu.Item>
)
